
import { AlertMenuType, CustomReportConfig } from '@/component/common/report/reportConfigModel'
import React from 'react'
import styled from 'styled-components'
import {  SettingOutlined } from '@ant-design/icons'
import { AlertMenuItem } from './AlertMenuItem'
import { AlertModal } from '../AlertModal/AlertModal'
import { quickBiReportAlertConfigUpdate } from '../AlertModal/services'
import { isError } from '@/component/common/error'
import AlertOperateBtn from '../asset/alert_operate_btn.png'
import { httpPc } from '@/utils/httpPc'

const AlertMenuHeaderView = styled.div`
  display: flex;
  height: 63px;
  align-items: center;
  padding: 0 15px;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
`


type AlertMenuHeaderProps = {
  alertMenu: AlertMenuType
  onChange(variable: AlertMenuType['variable']):void
  report:string

}

const AlertMenuHeader = (props:AlertMenuHeaderProps)=>{
  const { alertMenu,onChange } = props
  const [visible, setVisible] = React.useState(false);
  const [hasAuth,setHasAuth] = React.useState(false)
  const onOk = async  (variable: AlertMenuType['variable'])=>{
    let newVariable:Record<string,string> = {}
    Object.keys(variable).forEach(key=>{
      newVariable[key] = variable[key].key_value
    })
    let resData = await quickBiReportAlertConfigUpdate({report: props.report, config: newVariable})
    let res  = resData.data
    if(isError(res)){
      return
    }
    setVisible(false)
    onChange(variable)
  }
  const getAuth = async ()=>{
    let resData = await httpPc.get<AxiosHttpPromise<Record<'Manager/Report/quickBiReportAlertConfig',boolean>>>(`/RestfulApi/route/check?routes[]=Manager/Report/quickBiReportAlertConfig`);
    let res = resData.data
    if(isError(res)){
      return
    }
    if(process.env.NODE_ENV == 'development'){
      res.data['Manager/Report/quickBiReportAlertConfig'] = true
    }
    setHasAuth(res.data['Manager/Report/quickBiReportAlertConfig'])
  }
  React.useEffect(()=>{
    getAuth()
  },[])
  return  <AlertMenuHeaderView>
    <div>预警类别</div>
    {/* { hasAuth && <SettingOutlined onClick={()=>setVisible(true)} /> } */}
    { hasAuth &&  <img style={{width:'16px',cursor:'pointer'}} src={AlertOperateBtn} onClick={()=>setVisible(true)} /> } 
    <AlertModal alertMenu={props.alertMenu}  open={visible} onCancel={()=>setVisible(false)} onOk={onOk} />
  </AlertMenuHeaderView>
}




const AlertMenuView = styled.div`
  background-color: #fff;
  overflow-y: auto;
  height: 100%;
  .alert-menu-item{
    padding: 10px 15px;
    cursor: pointer;
    /* border-bottom: 1px solid #f0f0f0; */
    /* height: 43px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    &:hover{
      background-color: rgba(0, 0, 0, 0.04);
    }
    .name{
      font-size: 14px;
      font-weight: 400;
    }
    .alert-content{
      font-size: 12px;
      flex-wrap: wrap;
      color:rgba(0,0,0,0.45);
      font-size: 12px;
      display: block;
      white-space: pre-line;
    }
    &.active{
      background-color: #fff5f0; 
      border-left: 2px solid #ff6b40;
      padding-left: 13px;
    }
  }
`


export interface AlertMenuProps{
  alertMenu: CustomReportConfig['alertMenu'],
  onChangeVariable(variable: AlertMenuType['variable']):void
  onChangeAlertMenuItem(menu: AlertMenuType['menu'][0]):void
  menuItem?: AlertMenuType['menu'][0]
  report:string
}




export const AlertMenu = (props:AlertMenuProps)=>{
  const { alertMenu, onChangeVariable, onChangeAlertMenuItem,menuItem} = props
  const {variable} = alertMenu || {}
  if(!alertMenu || !variable){
    return null
  }
  const { menu } = alertMenu
  return <AlertMenuView>
    <AlertMenuHeader alertMenu={alertMenu} onChange={onChangeVariable} report={props.report} />
    { menu.map(item=>{
      let isActive = menuItem?.id == item.id
      return <div className={`alert-menu-item ${isActive ? 'active' : ''}`} key={item.id} onClick={()=>onChangeAlertMenuItem(item)}>
         <div className="name">{ item.key_name  }</div>
         <AlertMenuItem  variable={variable} menuItem={item} />
      </div>
    })}
  </AlertMenuView>
}